import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { compact } from 'lodash';
import styled from 'styled-components';

import { Chip } from 'LegacyWeployDesignLanguage/Tag';

const EndorserList = styled.p`
  margin-top: 0;
`;

const StyledChipWrapper = styled.div`
  & .MuiChip-root {
    background-color: ${props => props.theme.colors.white};
    border: 2px ${props => props.theme.colors.brand.primary} solid;
  }
`;

const listEndorsers = (organisations) => {
  const [organisation1, organisation2, ...otherOrganisations] = organisations;
  const numOtherOrganisations = otherOrganisations.length;
  const otherOrganisationsMessage = `${numOtherOrganisations} other${numOtherOrganisations === 1 ? '' : 's'}`;

  const output = compact([organisation1, organisation2, numOtherOrganisations >= 1 ? otherOrganisationsMessage : null]);
  return output.join(', ').replace(/, ([^,]*)$/, ' and $1');
};

const EndorsedSkills = ({ endorsedSkills }) => (
  <Fragment>
    { endorsedSkills.map((endorsedSkillData) => {
      const {
        id,
        name,
        organisationNames,
      } = endorsedSkillData;

      return (
        <div key={id}>
          <StyledChipWrapper>
            <Chip>{name}</Chip>
          </StyledChipWrapper>
          <EndorserList>{`Endorsed by ${listEndorsers(organisationNames)}`}</EndorserList>
        </div>
      );
    })}
  </Fragment>
);

EndorsedSkills.propTypes = {
  endorsedSkills: PropTypes.array,
};

EndorsedSkills.defaultProps = {
  endorsedSkills: [],
};

export default EndorsedSkills;
